// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountRoot.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import Login from './Izenda.Login';
import AccountStore from 'logic/Izenda.AccountStore';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';

const AccountRootContainer = ({ children }: { children: any }) => (
  <ScrollBox>
    <article className='izenda-Wrapper izenda-Account'>
      <header className='izenda-Account-Header u_block u_fullWidth u_textCenter u-posAbsolute'>
        <div className='izenda-Logo izenda-Account-logo u_inlineBlock u_fullHeight' />
      </header>
      <main className='izenda-Account-Main u_fullWidth u_textCenter u-posAbsolute'>{children}</main>
    </article>
  </ScrollBox>
);
export default { Component: Login, Container: AccountRootContainer, Store: AccountStore };



// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.AccountRoot.js